import React from "react";

import time_png from "../../../assets/Clock_Dark.svg";
import location_png from "../../../assets/location.svg";
import { TwListMoreButton, TwMoreOptions, TwRadialProgress } from "../../../components/tailwind";
import { cutString } from "../../../helpers";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForEvent } from "../../../utils/confighelpers";
import { useDispatch } from "react-redux";
import { setGlobalLoading } from "../../../redux/reducers/loadingReducer";
import { statusColors } from "../../../utils/constants";
import { useTranslation } from "react-i18next";

export default function SessionTile({
  imgSrc,
  title,
  time,
  venue,
  totalSeats,
  seatsBooked,
  seatsBookedPerc,
  bookedPeople,
  handleSessionClick,
  handleDuplicateAnEventClick,
  item,
  reloadData,
}) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const updateStatus = async (eventData, status) => {

    const config = {
      method: "put",
      url: `${getUrlForEvent()}schedule/update`,
      data: {
        eventScheduleId: eventData._id,
        eventStatus: status
      }
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        reloadData();
      }
    }
  };

  return (
    <li
      className={`my-3 p-4 flex flex-row items-center gap-4 cursor-pointer bg-white" : "bg-white hover:bg-[#e1e1e1] 1shadow-md border border-bright-gray rounded-2xl`}
    >
      <div className="flex flex-row items-center gap-4 w-full" onClick={() => { handleSessionClick(); }}>
        <div className="shrink-0 rounded-lg">
          <img className="w-24 sm:w-24 h-20 aspect-3/2 rounded-lg shadow-sm" src={imgSrc} alt="" />
        </div>
        <div className={`min-w-0 flex-auto flex flex-col gap-1`}>
          <p className="truncate text-base font-bold">{title}</p>
          <div className={"flex flex-row items-start gap-2"}>
            <img className={"w-3 h-3"} src={time_png} alt={""} />
            <p className={`text-granite-gray text-xs`} title={time}>
              {time}
            </p>
          </div>
          <div className={"flex flex-row items-start gap-2"}>
            <img className={"w-3 h-3"} src={location_png} alt={""} />
            <p className={`text-granite-gray text-xs line-clamp-1`} title={venue}>
              {/* {cutString(venue, 30, true)} */}
              {venue}
            </p>
          </div>
          <div className={"flex flex-row items-start gap-2"}>
            <div
              className={`p-1 px-2 mt-2 text-xs rounded-full`}
              style={{ ...(item?.eventStatus ? statusColors[item.eventStatus?.toLowerCase()] : {}) }}
            >
              {item?.eventStatus}
            </div>
          </div>
        </div>
        <div className={"hidden sm:flex flex-col items-center"}>
          <div className={"flex flex-col items-center"}>
            <TwRadialProgress progress={seatsBookedPerc} className="size-9" textClassName="!text-[9px]" />
            <h3 className={"text-light-secondary font-bold text-sm sm:text-base"}>
              {seatsBooked}/{totalSeats}
            </h3>
            <p className={"text-granite-gray text-xs text-center"}>
              {t("myschedule.ticketsSold")}
            </p>
          </div>
          <div className={"flex flex-row flex-wrap items-center"}>
            {false && Array.isArray(bookedPeople) && bookedPeople.length > 3 ? (
              <div
                className={`flex flex-row items-center mt-2 -space-x-2 overflow-hidden`}
              >
                {bookedPeople.slice(0, 3).map((person, i) => (
                  <div className='avatar' key={i}>
                    <div className='flex-none'>
                      <img src={person.profilePic} alt={person.fullName} title={person.fullName} className='rounded-full size-5 sm:size-6' />
                    </div>
                  </div>
                ))}
                <div className='avatar placeholder'>
                  <div
                    className={`flex justify-center items-center rounded-full font-semibold text-xs size-5 text-white bg-light-primary`}
                  >
                    <span>
                      +{bookedPeople.slice(bookedPeople.length - 2).length}
                    </span>
                  </div>
                </div>
              </div>
            ) : false && bookedPeople.length < 4 ? (
              <div
                className={`flex flex-row items-center mt-4 sm:mt-0 xl:mt-2 -space-x-2 overflow-hidden`}
              >
                {bookedPeople.map((person, i) => (
                  <div className='avatar' key={i}>
                    <div className='flex-none'>
                      <img src={person.profilePic} alt={person.fullName} title={person.fullName} className='rounded-full size-5 sm:size-6' />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
      <div className={"flex flex-col items-center ml-auto"}>
        <TwMoreOptions
          options={[
            <TwListMoreButton
              className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
              onClick={() => {
                handleSessionClick();
                // handleDateTimeModalOpen();
              }}
            >
              {t("inputFieldsTitle.view")}
            </TwListMoreButton>,
            <TwListMoreButton
              className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none truncate"
              disabled={item?.eventStatus == "Cancelled" ? true : false}
              onClick={() => {
                updateStatus(item, item?.eventStatus == "Published" ? "Draft" : "Published");
              }}
            >
              {item?.eventStatus == "Published" ? t("myschedule.markAsDraft") : t("myschedule.markAsPublished")}
            </TwListMoreButton>,
            <TwListMoreButton
              className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
              onClick={() => {
                handleDuplicateAnEventClick();
              }}
            >
              {t("myschedule.duplicatecreate")}
            </TwListMoreButton>
          ]} />
      </div>
    </li>
  );
}
